<template>
  <div>
    <pageContainer
      :formHeaderImage="NavImage"
      formHeaderImageAltText="GuardiansInformation Header Image"
      formHeaderImageClass="mb-4"
      formHeaderImageWidth="1000px"
      :isPageHeader="true"
    >
      <guardiansInfo />
    </pageContainer>

    <GetHelp v-if="false"></GetHelp>

    <b-modal v-model="isModalActive" :can-cancel="false" :scroll="false">
      <transition appear
                  @before-enter="$animations.beforeEnterBelow"
                  @enter="$animations.enterBelow"
      >
        <div class="opacity-select-card card" style="width: 80%; margin: auto; ">
          <header class="card-header">
            <p class="card-header-title is-centered is-size-4" style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.notice }}
            </p>
          </header>
          <div class="card-content" style="display: flex; justify-content: center">
            <div v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'">
            <p>{{ $root.selectedLanguageData.youAreExpectedToCompleteThisSection }}</p>
            </div>
            <div v-else-if="$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`">
              <ul class="example-ul mx-6 has-text-left">
                <li class="mb-3">
                  {{$root.selectedLanguageData.sinceYouAreOpeningThisAccountAsAGiftAccount}}
                </li>
                <li class="mb-3">
                  {{$root.selectedLanguageData.pleaseFillOutTheUpcomingSectionWithTheGuardianDetails}}
                </li>

                <li class="mb-3">
                  {{$root.selectedLanguageData.onceTheGuardianHasSuccessfullyCompleted}}
                </li>
              </ul>
            </div>
          </div>
          <div class="card-content" style="display: flex; justify-content: center">
            <b-button
                style="margin: 0 auto"
                class="is-primary agree-button"
                :loading="continueButtonIsLoading"
                @click="()=>{

                  isModalActive = false
                }"
            >
              {{ $root.selectedLanguageData.ok }}
            </b-button>
          </div>
        </div>
      </transition>
    </b-modal>

  </div>
</template>

<script>
import GetHelp from "./GetHelp.vue";
import pageContainer from "./supports/page-container/page-container.vue";
import guardiansInfo from "../components/supports/pages/guardians-information.vue";
import guardiansInfoNavImage from "../assets/images/icons/updatedIcons/kekuluFlow/guardiansInfo.png";
import guardiansDonorNavImage from "../assets/images/icons/updatedIcons/donorFlow/guardiansInfo.png";

export default {
  components: {
    GetHelp,
    pageContainer,
    guardiansInfo,
  },
  data() {
    return {
      isModalActive : true,
      NavImage : '',
    };
  },
  methods: {
    showImage(){
      if(this.$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`){
        this.NavImage = guardiansDonorNavImage
        
      }else{
        this.NavImage = guardiansInfoNavImage
      }
    }
  },

  watch: {},
  mounted()
  {
    this.showImage()
  }
};
</script>
<style lang="scss" scoped>
ul li::before {
  content: "\2022";
  color: #009ec2;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}
.specific {
  margin-left: -20px;
  line-height: 1.5rem;
}


</style>
